import { useEffect, useMemo, useState } from "react";
import moment from "jalali-moment";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import { getApi } from "../../../services/api/globalApi";
import { inactiveUserCustomersReportsColumns } from "../../../constant/tablesColumns/tablesColums";
import { digitsThree } from "../../../utils/price";
import { errorMessage } from "../../../utils/toastify-message/ToastifyMessage";
import InactiveUserCustomersReportsFilter from "./InactiveUserCustomersReportsFilter";

const formatDate = (date) =>
  date ? moment(date).format("jYYYY/jMM/jDD") : "-";

export default function InactiveUserCustomersReports() {
  const [reportsData, setReportsData] = useState([]);
  const [activeSearchButton, setActiveSearchButton] = useState(true);

  const getReports = async (params) => {
    const path = "admin/reports/inactiveUserCustomers";
    try {
      setActiveSearchButton(false);
      const response = await getApi({ path, params: { ...params } });
      const result = response?.data?.result || [];
      setReportsData(
        result.map((item) => ({
          ...item,
          lastPaymentDateText: formatDate(item.lastPaymentDate),
          sumFinalPriceText: digitsThree(item.sumFinalPrice),
        }))
      );
    } catch (error) {
      errorMessage(
        error?.response?.data?.errors?.[0]?.message ||
          "دریافت گزارش با خطا مواجه شد"
      );
      setReportsData([]);
    } finally {
      setActiveSearchButton(true);
    }
  };

  useEffect(() => {
    getReports({ role: "seller", months: 12 });
  }, []);

  const excelData = useMemo(
    () =>
      reportsData.map((item) => ({
        "نام مشتری": item.name,
        "شماره تماس مشتری": item.mobile,
        "آخرین خرید": item.lastPaymentDateText,
        "روز از آخرین خرید": item.daysSinceLastOrder,
        "تعداد سفارش": item.sumTotalOrders,
        "مجموع خرید": item.sumFinalPrice,
        "نام مشاور": item.consultantName,
        "شماره تماس مشاور": item.consultantMobile,
        "کد معرف مشاور": item.consultantRefCode,
      })),
    [reportsData]
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"مشتریان غیرفعال مشاوران"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel jsonData={excelData} />
        </div>
      </div>
      <InactiveUserCustomersReportsFilter
        filterDataHandler={getReports}
        activeSearchButton={activeSearchButton}
      />
      <p className="px-6 text-sm text-gray-600 dark:text-gray-300">
        تعداد مشتریان: {reportsData.length}
      </p>
      <Table
        columns={inactiveUserCustomersReportsColumns}
        rows={reportsData}
      />
    </div>
  );
}
